import { Box, Chip } from '@mui/material';
import { memo } from 'react';

// Properties are via SubscriptionServiceByIdItem
type ServiceFlagsFieldProps = {
  isDisabled?: boolean;
  isHidden?: boolean;
  isTestmode?: boolean;
};

export const ServiceFlagsField = memo(
  ({ isDisabled, isHidden, isTestmode }: ServiceFlagsFieldProps) => (
    <Box
      sx={{
        display: 'flex',
        gap: 1,
      }}
    >
      {isDisabled ? (
        <Chip
          label="Disabled"
          sx={{ backgroundColor: 'error.main', color: 'white' }}
          size="small"
        />
      ) : (
        <Chip
          label="Live"
          color="success"
          size="small"
        />
      )}
      {isHidden && (
        <Chip
          label="Hidden"
          sx={{ backgroundColor: 'warning.main', color: 'white' }}
          size="small"
        />
      )}
      {isTestmode && (
        <Chip
          label="Test"
          sx={{ backgroundColor: 'primary.main', color: 'white' }}
          size="small"
        />
      )}
    </Box>
  ),
);
ServiceFlagsField.displayName = 'ServiceFlagsField';
